export default {
  'STATUSPEND' (state) {
    return state.statusPend
  },
  'STATUSPENDS' (state) {
    return state.statusPends
  }
}
